import { PagingApiModel } from '@/types/api';
import { UserModel } from '@/types/users';
import { TeamMemberModel } from '@/types/teams';

export type GoalStage = 0 | 1 | 2 | 3 | 4;

export enum GoalStageReason {
  PROGRESS_TYPE_0 = '記録を始めてみましょう！',
  PROGRESS_TYPE_1 = 'GOAL達成！新たな目標を設定しよう！',
  PROGRESS_TYPE_2 = '素晴らしい成果！次の目標へ！',
  PROGRESS_TYPE_3 = 'ゴールは目の前！ラストスパート！',
  PROGRESS_TYPE_4 = '安定したパフォーマンスを続けよう！',
  PROGRESS_TYPE_5 = 'この流れをキープしよう！',
  PROGRESS_TYPE_6 = 'さらに高評価を目指そう！',
  PROGRESS_TYPE_7 = '良い調子！目指せ高評価の記録！',
  PROGRESS_TYPE_8 = '継続は力なり！まずは記録を増やそう！'
}

export const getGoalStageReasonString = (reason: string): string | undefined => {
  const reasonEnum = GoalStageReason[reason as keyof typeof GoalStageReason];
  return reasonEnum ? reasonEnum : undefined;
};

export interface GoalApiModel {
  goal: GoalModel;
}

export interface GoalsApiModel {
  has_more?: boolean;
  goals: GoalModel[];
}

export interface TeamMembersGoalsApiModel {
  has_more?: boolean;
  goals: TeamMemberGoalModel[];
}

export interface GoalsPagingApiModel extends GoalsApiModel, PagingApiModel {}

/**
 * APIモデル チームページ 目標ページング用リストモデル
 */
export interface TeamMembersGoalsPagingApiModel extends TeamMembersGoalsApiModel, PagingApiModel {
  team_members: TeamMemberModel[];
}

export interface GoalModel {
  id: number;
  user_id: number;
  immediate_goal: string;
  activated: boolean;
  deleted: boolean;
  created_at: string;
  updated_at: string;
  max_stats_log?: { id: number; date: string; stats: number; title: string };
  progress: { stage: GoalStage; reason_code: string };
}

export interface TeamMemberGoalModel {
  id: number;
  user: UserModel;
  immediate_goal: string;
  activated: boolean;
  created_at: string;
  updated_at: string;
}

export interface GoalCreateDataModel {
  immediate_goal: string;
}

export interface GoalUpdateDataModel {
  id: number;
  immediate_goal: string;
}
